<script>
import { computed, defineComponent } from '@vue/composition-api';
import DashboardStoreSelect from './DashboardStoreSelect.vue';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';

export default defineComponent({
  components: {
    DashboardStoreSelect,
  },
  setup(props, { root }) {
    const profile = computed(() => root.$store.getters.getProfile);
    const {
      currentRevenue,
      formatDate,
      currentDate,
      updatedAt,
      storeSelected,
      changeStoreSelected,
    } = useManagerDashboard();
    const { stores: sellerStores, loading: loadingStores } = useVuexSellerStores(root);

    return {
      storeSelected,
      changeStoreSelected,
      sellerStores,
      loadingStores,
      currentRevenue,
      formatDate,
      profile,
      currentDate,
      updatedAt,
    };
  },
});
</script>

<template>
  <div class="header">
    <h1 class="header__description">
      <span class="header__description__seller"> Olá,<strong> {{ profile.name }} </strong> </span>
    </h1>
    <h1 class="header__description__subtitle">
      Acompanhe seus resultados:
    </h1>
    <div class="header__date">
      {{ currentDate }}
      <h3 class="header__date__update">
        Atualizado em: {{ updatedAt.date }} às {{ updatedAt.hours }}
      </h3>
    </div>
    <DashboardStoreSelect
      :change-store-selected="changeStoreSelected"
      :loading="loadingStores"
      :stores="sellerStores"
      :store-selected="storeSelected"
    />
  </div>
</template>

<style lang="scss" scoped>
.header {
  &__description {
    font-weight: 400;
    font-size: 18pt;
    &__seller {
      font-family: 'Neue-Metana';
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 22px;
    }
    &__subtitle {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
    }
  }
  &__date {
    margin-top: 2rem;
    font-size: 12pt;
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    &__update {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
      /* identical to box height */
      color: #959595;
    }
  }
}
</style>
